import { useEffect, useState } from "react";
import { SelectionBar } from "./components/SelectionBar";
import { TabHeader } from "./components/TabHeader";
import { TableData } from "./components/TableData";
import { UpdateFavouriteModal } from "@components/templates/UpdateFavouriteModal";
import { profileType } from "@utils/enum";
import SalesforceDuplicateModal from "@shared/salesforce-duplicate-modal";
import { useDispatch, useSelector } from "react-redux";
import { closeSalesforceModal, loadingBookmarkData, resetBookmarkData } from "@redux/Bookmark/bookmarksSlice";
import { shipmentsPayload } from "./utils/constant";
import { getFavouriteDetailsHandler } from "@redux/Bookmark/bookmark.action";
import LoadingSkeleton from "@shared/LoadingSkeleton";
import IntelLayout from "@components/layout/layout";
import { FavouriteNoData } from "../../components/templates/Favourite/FavouriteNoData/FavouriteNoData";
import { FavouriteDownloadModal } from "@components/templates/Favourite/FavouriteDownloadModal";
import { FavouriteSingleDeleteModal } from "@components/templates/Favourite/FavouriteSingleDeleteModal";

const sortEnum = [{ columnKey: "date", value: "date" }];

export const ShipmentsBookmark = () => {
  const [showNotification, setShowNotification] = useState(false);
  const [showFavModal, setShowFavModal] = useState(false);
  const [selectedCompanyArray, setSelectedCompanyArray] = useState([]);
  const [showContactModal, setShowContactModal] = useState(false);
  const [clearSelectedCompanies, setClearSelectedCompanies] = useState(false);
  const [downloadModal, setDownloadModal] = useState(false);
  const [payload, setPayload] = useState(shipmentsPayload);
  const [type, setType] = useState(profileType.shipments);
  const bookmarkDetails = useSelector((state) => state.bookmarkDetails);
  const [perPage, setPerPage] = useState(10);
  const [currentpage, setCurrentPage] = useState(1);
  const [singleData, setSingleData] = useState({});
  const [search, setSearch] = useState("");
  const [filterCount, setFilterCount] = useState(0);
  const [showSingleData, setShowSingleData] = useState(false);
  const [sortField, setSortField] = useState(sortEnum[0].value);
  const [sortOrderValue, setSortOrderValue] = useState("desc");

  const dispatch = useDispatch();
  const {
    duplicateSalesforce: { showDuplicateModal, duplicateCount, duplicateData, fuzzyData },
  } = bookmarkDetails;
  let timer = null;

  useEffect(() => {
    dispatch(loadingBookmarkData());
    dispatch(resetBookmarkData());
    dispatch(getFavouriteDetailsHandler({ payload: shipmentsPayload }));
    setType(profileType.shipments);
    setPayload(shipmentsPayload);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    getCountHandler();
  }, [payload]);

  const getCountHandler = () => {
    if (payload && Object.keys(payload)?.length) {
      let count = 0;
      Object.keys(payload.filters)?.map((item) => {
        count += payload.filters[item].length;
      });
      setFilterCount(count);
    }
  };

  const clearSelection = () => {
    setSelectedCompanyArray([]);
    let clearSelection = clearSelectedCompanies;
    setClearSelectedCompanies(!clearSelection);
    timer = setTimeout(() => {
      setClearSelectedCompanies(clearSelection);
    }, 200);
  };

  return (
    <IntelLayout
      setNotification={(val) => {
        setShowNotification(val);
      }}
      showNotification={showNotification}
      userDetails={() => {
        return;
      }}
      userPlanDetails={() => {
        return;
      }}
      type={"shipmentsBookmark"}
      pageTitle="Shipment Bookmarks | Trademo Intel">
      <div>
        {!bookmarkDetails?.bookmarkData?.loading && !bookmarkDetails?.bookmarkData?.data?.length && !search && !filterCount ? (
          <FavouriteNoData type={type} />
        ) : (
          <div className="mt-3">
            <div>
              <TabHeader setCurrentPage={setCurrentPage} clearSelection={clearSelection} type={type} search={search} setSearch={setSearch} payload={payload} setPayload={setPayload} />
            </div>
            {selectedCompanyArray.length ? <SelectionBar type={type} selectedCompanyArray={selectedCompanyArray} setDownloadModal={setDownloadModal} setShowDeleteModal={setShowSingleData} clearSelection={clearSelection} setShowContactModal={setShowContactModal} setShowFavModal={setShowFavModal} setSelectedCompanyArray={setSelectedCompanyArray} /> : null}
            {bookmarkDetails?.bookmarkData?.loading ? (
              <div className="mt-3">
                <LoadingSkeleton lines={10} lineHeight={"40px"} width={"100%"} shape="rectangle" widthArr={["100%", "100%", "100%", "100%"]} />
              </div>
            ) : !bookmarkDetails?.bookmarkData?.data?.length && (search || filterCount) ? (
              <FavouriteNoData type={type} message="No results match your search criteria" />
            ) : (
              <TableData sortEnum={sortEnum} sortField={sortField} setSortField={setSortField} sortOrderValue={sortOrderValue} setSortOrderValue={setSortOrderValue} singleData={singleData} setSingleData={setSingleData} currentpage={currentpage} setCurrentPage={setCurrentPage} perPage={perPage} setPerPage={setPerPage} setPayload={setPayload} payload={payload} type={type} clearSelectedCompanies={clearSelectedCompanies} showContactModal={showContactModal} setShowContactModal={setShowContactModal} selectedCompanyArray={selectedCompanyArray} showFavModal={showFavModal} setSelectedCompanyArray={setSelectedCompanyArray} setShowFavModal={setShowFavModal} />
            )}
            {showSingleData ? <FavouriteSingleDeleteModal setCurrentPage={setCurrentPage} setSingleData={setSingleData} setPayload={setPayload} type={type} payload={shipmentsPayload} selectedCompany={selectedCompanyArray} showSingleData={showSingleData} setShowSingleData={setShowSingleData} /> : ""}
            {showFavModal ? <UpdateFavouriteModal setPayload={setPayload} setSingleData={setSingleData} type={type} clearSelection={clearSelection} payload={payload} profileType={profileType.shipments} showFavModal={showFavModal} selectedCompanyArray={Object.keys(singleData).length ? [singleData] : selectedCompanyArray} setShowFavModal={setShowFavModal} /> : <></>}
            {showDuplicateModal ? <SalesforceDuplicateModal closeButton={() => dispatch(closeSalesforceModal())} showButton={showDuplicateModal} duplicateCount={duplicateCount} duplicateData={duplicateData} fuzzyData={fuzzyData} type="companies" /> : <></>}
            {downloadModal ? <FavouriteDownloadModal type={type} clearSelection={clearSelection} downloadModal={downloadModal} handleClose={() => setDownloadModal(false)} selectedCompanyArray={selectedCompanyArray} /> : <></>}
          </div>
        )}
      </div>
    </IntelLayout>
  );
};
